import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { BaseTableContainer } from './style';
import { IElement } from 'lib/common/types';
import { brand } from 'themes/brand';

interface ITableBody {
  name: string;
  logo: string;
  consultants: IElement[];
  status: string;
  actions: JSX.Element;
}

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: brand.tint,
    color: brand.text,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: brand.white,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function CustomizedTable(props: {
  tableHead: string[];
  tableBody: ITableBody[];
}) {
  return (
    <BaseTableContainer>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            {props.tableHead.map((item, index) => (
              <StyledTableCell key={index}>{item}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.tableBody.map((item, index) => {
            return (
              <StyledTableRow key={index}>
                <StyledTableCell align="left">{item.name}</StyledTableCell>
                <StyledTableCell align="left">
                  <img src={item.logo} alt="logotipo" />
                </StyledTableCell>
                <StyledTableCell align="left">
                  {item.consultants.map((el) => (
                    <p>{el.name}</p>
                  ))}
                </StyledTableCell>
                <StyledTableCell align="left">{item.status}</StyledTableCell>
                <StyledTableCell align="right">{item.actions}</StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </BaseTableContainer>
  );
}
